'use client';

import { cn } from '@/lib/utils';
import * as SliderPrimitive from '@radix-ui/react-slider';
import * as React from 'react';

const SliderExtended = ({
  className,
  classNameTrack,
  classNameThumb,
  ...props
}: React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
  classNameTrack?: string;
  classNameThumb?: string;
}) => {
  const initialValue = Array.isArray(props.value)
    ? props.value
    : [props.min, props.max];

  return (
    <SliderPrimitive.Root
      className={cn(
        'relative flex w-full touch-none select-none items-center',
        className,
      )}
      {...props}
    >
      <SliderPrimitive.Track
        className={cn(
          'bg-secondary relative h-2 w-full grow overflow-hidden rounded-full',
          classNameTrack,
        )}
      >
        <SliderPrimitive.Range className='bg-primary absolute h-full' />
      </SliderPrimitive.Track>
      {initialValue.map((value, index) => (
        <React.Fragment key={index}>
          <SliderPrimitive.Thumb
            className={cn(
              'border-primary bg-background ring-offset-background focus-visible:ring-ring block h-4 w-4 cursor-grab rounded-full border-2 transition-colors focus:cursor-grabbing focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
              classNameThumb,
            )}
          />
        </React.Fragment>
      ))}
    </SliderPrimitive.Root>
  );
};
SliderExtended.displayName = 'SliderExtended';

export { SliderExtended };
